// Player accent colors (repeating pattern)
const PLAYER_COLORS = ['#FBBF24', '#60A5FA', '#A78BFA', '#F87171', '#34D399', '#FB923C', '#22D3EE', '#F472B6'];
export const getPlayerColor = (index) => PLAYER_COLORS[index % PLAYER_COLORS.length];

export const calculateScore = (bid, won, prevBags) => {
    let score = 0;
    let bags = 0;
    let bagPenalty = 0;

    const bidNum = Number(bid);
    if (won >= bidNum) {
        score = bidNum * 10 + (won - bidNum);
        bags = won - bidNum;
    } else {
        score = -bidNum * 10;
        bags = 0; // No bags when you fail
    }

    // Calculate bag penalty (Disabled per user request)
    // const totalBagsBeforePenalty = prevBags + bags;
    // const bagsSoFar = totalBagsBeforePenalty;

    // if (Math.floor(bagsSoFar / 10) > Math.floor(prevBags / 10)) {
    //     bagPenalty = -100;
    // }

    const bagsSoFar = prevBags + bags;

    return {
        score,
        bags,
        bagPenalty: 0, // No penalty
        newBags: bagsSoFar, // Don't reset bags
        totalBags: bagsSoFar
    };
};

export const calculateAdvancedStats = (handHistory, playerName) => {
    let bestHand = { score: -Infinity, handNumber: 0 };
    let worstHand = { score: Infinity, handNumber: 0 };
    let currentStreak = 0;
    let maxStreak = 0;

    handHistory.forEach((hand, index) => {
        const playerHand = hand.players[playerName];
        if (!playerHand) return;

        // Best/Worst Hand
        if (playerHand.score > bestHand.score) {
            bestHand = { score: playerHand.score, handNumber: index + 1 };
        }
        if (playerHand.score < worstHand.score) {
            worstHand = { score: playerHand.score, handNumber: index + 1 };
        }

        // Streak (Made Bid)
        // Assuming 0 bid requires 0 wins to maintain streak if we treat it as Nil,
        // but if it's just a number, won >= bid is fine.
        // Given "Nil Master" exists, 0 is likely special.
        // Let's assume strict Nil rules for streak: if bid is 0, must win 0.
        const bidNum = Number(playerHand.bid);
        const wonNum = playerHand.won;

        let madeBid = false;
        if (bidNum === 0) {
            madeBid = wonNum === 0;
        } else {
            madeBid = wonNum >= bidNum;
        }

        if (madeBid) {
            currentStreak++;
            maxStreak = Math.max(maxStreak, currentStreak);
        } else {
            currentStreak = 0;
        }
    });

    return { bestHand, worstHand, maxStreak };
};

export const calculateAchievements = (handHistory, playerName) => {
    const achievements = [];
    let totalBags = 0;
    let perfectBids = 0; // Won exactly what was bid
    let totalHands = 0;

    handHistory.forEach(hand => {
        const playerHand = hand.players[playerName];
        if (!playerHand) return;
        totalHands++;

        const bidNum = Number(playerHand.bid);
        const wonNum = playerHand.won;

        // Sandbagger: Accumulate bags
        if (bidNum > 0) {
            if (wonNum > bidNum) {
                totalBags += (wonNum - bidNum);
            }
            if (wonNum === bidNum) {
                perfectBids++;
            }
        }


    });

    if (totalBags >= 10) {
        achievements.push({
            id: 'sandbagger',
            icon: '💼',
            title: 'Sandbagger',
            description: 'Accumulated 10+ bags',
            color: 'text-amber-400'
        });
    }



    if (totalHands >= 5 && perfectBids === totalHands) {
        achievements.push({
            id: 'sniper',
            icon: '🎯',
            title: 'Sniper',
            description: '100% Perfect Bids',
            color: 'text-red-400'
        });
    } else if (totalHands >= 10 && (perfectBids / totalHands) >= 0.8) {
        achievements.push({
            id: 'sharpshooter',
            icon: '🏹',
            title: 'Sharpshooter',
            description: '80%+ Perfect Bids',
            color: 'text-emerald-400'
        });
    }

    return achievements;
};

export const calculatePersona = (stats) => {
    const { riskLevel, averageBags, averageTricksWon } = stats;

    if (riskLevel > 80) return { name: "The Gambler", icon: "🎲", desc: "High risk, high reward", color: "text-red-400" };
    if (riskLevel < 30) return { name: "The Rock", icon: "🗿", desc: "Plays it safe", color: "text-gray-400" };
    if (averageBags > 1.5) return { name: "Sandbagger", icon: "💼", desc: "Hoards bags", color: "text-amber-600" };
    if (averageTricksWon > 4) return { name: "The Shark", icon: "🦈", desc: "Dominates tricks", color: "text-blue-400" };

    return { name: "The Strategist", icon: "🧠", desc: "Balanced play", color: "text-purple-400" };
};

export const calculateRivalry = (player, allPlayers) => {
    if (allPlayers.length < 2) return null;

    // Find player with closest score
    const rivals = allPlayers
        .filter(p => p.name !== player.name)
        .map(p => ({
            ...p,
            diff: Math.abs(p.score - player.score)
        }))
        .sort((a, b) => a.diff - b.diff);

    return rivals[0];
};
